import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ROUTE_CONSTANTS, STRING_CONSTANTS } from '../../constants/common';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isChecking, setIsChecking] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuthentication = () => {
      try {
        // Check for authentication token in localStorage
        const token = localStorage.getItem('authToken') || 
                     localStorage.getItem('access_token') ||
                     localStorage.getItem(STRING_CONSTANTS?.STORED_KEYS?.AUTH_TOKEN) ||
                     localStorage.getItem(STRING_CONSTANTS?.STORED_KEYS?.ACCESS_TOKEN);

        if (token && token.trim() && token !== 'null' && token !== 'undefined') {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Error checking authentication:', error);
        setIsAuthenticated(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkAuthentication();
  }, []);

  // Show loading state while checking authentication
  if (isChecking) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        {STRING_CONSTANTS.LABELS.CHECKING_AUTHENTICATION}
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={ROUTE_CONSTANTS.AUTH.LOGIN} state={{ from: location }} replace />;
  }

  // Render protected content if authenticated
  return children;
};

export default ProtectedRoute;

